import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter } from "react-router-dom";
import { RouterProvider, Navigate } from "react-router-dom";
import "./translate/i18n.jsx";

// Importando as páginas
import Home from "./Pages/Home.jsx";
import SobreNos from "./Pages/SobreNos.jsx";
import Castanha from "./Pages/Castanha.jsx";
import Producao from "./Pages/Producao.jsx";
import FaleConosco from "./Pages/FaleConosco.jsx";
import NotFound from "./Pages/NotFound.jsx";
import ReceitasSalgadas from "./Pages/ReceitasSalgadas.jsx";
import ReceitasDoces from "./Pages/ReceitasDoces.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/", element: <Navigate to="/pt" /> },
      { path: "/pt", element: <Home /> },
      { path: "/pt/sobre-nos", element: <SobreNos /> },
      { path: "/pt/castanha", element: <Castanha /> },
      { path: "/pt/producao", element: <Producao /> },
      { path: "/pt/fale-conosco", element: <FaleConosco /> },
      { path: "/pt/receitas-salgadas", element: <ReceitasSalgadas /> },
      { path: "/pt/receitas-doces", element: <ReceitasDoces /> },

      // Rotas em inglês
      { path: "/en", element: <Home /> },
      { path: "/en/about-us", element: <SobreNos /> },
      { path: "/en/cashew", element: <Castanha /> },
      { path: "/en/production", element: <Producao /> },
      { path: "/en/contact-us", element: <FaleConosco /> },
      { path: "/en/savory-recipes", element: <ReceitasSalgadas /> },
      { path: "/en/sweet-recipes", element: <ReceitasDoces /> },

      // 404 - NotFound
      { path: "*", element: <NotFound /> }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
